import { EmailDomain } from 'types/domains';

export const getEmailDomain = (email: string): string => {
  if (email) {
    const parts = email.split('@');
    if (parts.length >= 2) {
      return parts[parts.length - 1];
    }
    return '';
  }
  return '';
};

export const findDomain = (dataArray: string[]): string => {
  if (dataArray && dataArray.some((data) => data.includes('google.com'))) {
    return EmailDomain.Gmail;
  }
  if (dataArray && dataArray.some((data) => data.includes('outlook.com'))) {
    return EmailDomain.Outlook;
  }
  if (dataArray && dataArray.some((data) => data.includes('icloud.com'))) {
    return EmailDomain.Apple;
  }
  if (dataArray && dataArray.some((data) => data.includes('yahoodns.net'))) {
    return EmailDomain.Yahoo;
  }
  return '';
};

export const createNameFromEmail = (email: string): string => {
  let username = email.split('@')[0];

  if (username.includes('+')) {
    [username] = username.split('+');
  }

  const cleanUsername = username.replace(/[^a-zA-Z0-9\s]/g, ' ');
  const formattedName = cleanUsername
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');

  return formattedName;
};
